module.exports = __webpack_public_path__ + "static/facebook.786ff613.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/UseCases/facebook.png
// module id = 519
// module chunks = 44921922015344